/* ICE Box homepage: swatch crossfades, scroll reveals, folder fan, sticky bar */
(function () {
  function wire(group) {
    var img = document.getElementById(group.dataset.target || 'heroImg');
    var label = document.getElementById(group.dataset.label || 'swLabel');
    var card = group.closest('.pcard');
    var variantInput = card ? card.querySelector('.pcard__variant') : null;
    var btn = card ? card.querySelector('.pcard__form .btn') : null;
    if (btn) btn.dataset.label = btn.textContent;
    var sws = group.querySelectorAll('button.sw');
    sws.forEach(function (s) {
      s.addEventListener('click', function () {
        sws.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        s.setAttribute('aria-pressed', 'true');
        if (img && s.dataset.img) {
          img.classList.add('swap');
          var pre = new Image();
          pre.onload = pre.onerror = function () { img.removeAttribute('srcset'); img.src = s.dataset.img; img.alt = 'ICE Box in ' + s.dataset.color; img.classList.remove('swap'); };
          pre.src = s.dataset.img;
        }
        if (label) label.textContent = (group.dataset.target ? '' : 'Classic · ') + s.dataset.color;
        if (variantInput && s.dataset.variant) variantInput.value = s.dataset.variant;
        if (btn) { if (s.dataset.soldout) { btn.setAttribute('disabled', ''); btn.textContent = 'Sold out in ' + s.dataset.color; } else { btn.removeAttribute('disabled'); btn.textContent = btn.dataset.label; } }
      });
    });
  }
  document.querySelectorAll('.swatches').forEach(wire);

  var targets = document.querySelectorAll('.rv, #fan');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode)) {
    // only hide what is still below the fold, so nothing on screen flashes
    targets.forEach(function (e) { if (e.getBoundingClientRect().top < innerHeight) e.classList.add('in'); });
    document.documentElement.classList.add('ib-anim');
  }
  if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { targets.forEach(function (e) { e.classList.add('in'); }); }
  else {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
    targets.forEach(function (e) { io.observe(e); });
    setTimeout(function () { document.querySelectorAll('.rv:not(.in), #fan:not(.in)').forEach(function (e) { if (e.getBoundingClientRect().top < innerHeight) e.classList.add('in'); }); }, 1500);
  }

  var st = document.getElementById('sticky'), hero = document.getElementById('top');
  if (st && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { var on = !e[0].isIntersecting; st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); }, { threshold: 0 }).observe(hero);
  }
})();
